import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Page({ as, className, children, ...rest }) {
    const Component = as ?? "div";
    return (_jsx(Component, { className: classNames("cvr-page", className), ...rest, children: children }));
}
